"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInvitationConfig = void 0;
// import { config } from '../index'
const { projectCode, stage } = process.env;
const appUrl = stage === 'prod' ? 'https://app.watertogrow.com' : `https://v3.${stage}.${projectCode === null || projectCode === void 0 ? void 0 : projectCode.substring(0, 4)}.iotv.link`;
// const supportEmail = config?.apps?.webUI?.supportEmail
const emailBody = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">

</head>
<div>
Welcome {username}, 
</div>
<div>
You have been granted access to Water to Grow.
</div>
<div>
Please use this link to access the system: <a href="${appUrl}">WaterToGrow</a>. 
</div>
<div>
Your username is: <b>{username}</b>.
</div>
Your password (valid for 7 days) is <b>{####}</b>
<div>
If you need any support with this process, or for any other questions, please contact us at <a href="support@watertogrow.com">support@watertogrow.com</a>
</div>`;
exports.userInvitationConfig = {
    emailSubject: `Welcome to Water to Grow`,
    emailBody,
};
